export enum CsvColumnSeparator {
	',' = 0,
	';' = 1,
	'|' = 2,
	':' = 3,
	'.' = 4,
}
